import React from "react";
import { Menu } from "antd";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import {
  UserOutlined,
  HomeOutlined,
  CloudUploadOutlined,
  ContactsOutlined,
  FolderOpenOutlined,
  TeamOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  BankOutlined,
  SolutionOutlined
} from "@ant-design/icons";

/**
 * MenuItems
 * @param {Boolean} isMenuCollapsed
 * @param {Function} closeDrawer
 */
function MenuItems({ isMenuCollapsed = false, closeDrawer = null }) {
  const { pathname } = useLocation();
  const { isAdmin, isVisitante } = useAuth();

  return (
    <Menu selectedKeys={[pathname]} mode="inline" theme="light" inlineCollapsed={isMenuCollapsed}>
      {(isAdmin || isVisitante) && (
        <Menu.Item onClick={closeDrawer} key="/app" icon={<HomeOutlined />}>
          <Link to="/app">Inicio</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/transferencia" icon={<CloudUploadOutlined />}>
          <Link to="/app/transferencia">Carga de datos</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/registrador" icon={<ContactsOutlined />}>
          <Link to="/app/registrador">Registradores</Link>
        </Menu.Item>
      )}

      {(isAdmin || isVisitante) && (
        <Menu.Item onClick={closeDrawer} key="/app/postulante" icon={<TeamOutlined />}>
          <Link to="/app/postulante">Postulante</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/ingresante" icon={<TeamOutlined />}>
          <Link to="/app/ingresante">Ingresante</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/participante" icon={<SolutionOutlined />}>
          <Link to="/app/participante">Participante</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/estructura" icon={<BankOutlined />}>
          <Link to="/app/estructura">Estructura</Link>
        </Menu.Item>
      )}

      {(isAdmin || isVisitante) && (
        <Menu.Item onClick={closeDrawer} key="/app/asistencia" icon={<PlayCircleOutlined />}>
          <Link to="/app/asistencia">Asistencias</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/usuarios" icon={<UserOutlined />}>
          <Link to="/app/usuarios">Usuarios</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/reportes" icon={<FolderOpenOutlined />}>
          <Link to="/app/reportes">Reportes</Link>
        </Menu.Item>
      )}

      {isAdmin && (
        <Menu.Item onClick={closeDrawer} key="/app/configuracion" icon={<SettingOutlined />}>
          <Link to="/app/configuracion">Confirguración</Link>
        </Menu.Item>
      )}

      {/* Roles visitante */}
    </Menu>
  );
}
export default MenuItems;
